import langFilter from '../filters/lang.filter'

export default {
    install(Vue){
        Vue.prototype.$title = function (key){
            return `${langFilter(key)} | CRM` || ''
        }
    }
}